export enum CertificateTypes {
	None = 0,
	TwoDotOne = 1,
	ThreeDotOne = 2,
}
